class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = this.closest('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    if (this.summary.textContent.trim().toLowerCase() === 'products') {
      this.mainDetailsToggle.dataset.menuHandle = 'products';
    }
  }

  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('pointerenter', (event) => {
      if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
      clearTimeout(this.closeTimer);
      clearTimeout(this.openTimer);
      this.openTimer = setTimeout(() => this.open(), 120);
    }, options);
    this.addEventListener('pointerleave', () => {
      clearTimeout(this.openTimer);
      if (!this.hoverQuery.matches) return;
      this.closeTimer = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 240);
    }, options);
    this.summary.addEventListener('click', () => {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (!this.mainDetailsToggle.open) this.closeOtherMenus();
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.mainDetailsToggle.open) return;
      event.preventDefault();
      this.close();
      this.summary.focus();
    }, options);
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.close();
    }, options);
    this.hoverQuery.addEventListener('change', () => {
      if (!this.hoverQuery.matches) this.close();
    }, options);
  }

  disconnectedCallback() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    this.controller?.abort();
  }

  open() {
    if (!this.isConnected) return;
    this.closeOtherMenus();
    this.mainDetailsToggle.open = true;
    this.summary.setAttribute('aria-expanded', 'true');
  }

  close() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    super.close();
  }

  closeOtherMenus() {
    this.header?.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle.open;
    this.summary.setAttribute('aria-expanded', String(isOpen));
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));
    if (isOpen) {
      document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
    }
  }
}

customElements.define('header-menu', HeaderMenu);

